"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Carousel = void 0;
var react_1 = __importDefault(require("react"));
var Container_1 = require("../Container");
var CarouselContext_1 = require("./CarouselContext");
var Carousel = function (_a) {
    var className = _a.className, _b = _a.loopeable, loopeable = _b === void 0 ? false : _b, _c = _a.index, index = _c === void 0 ? 0 : _c, _d = _a.nbVisibleItems, nbVisibleItems = _d === void 0 ? 1 : _d, onChange = _a.onChange, children = _a.children, rest = __rest(_a, ["className", "loopeable", "index", "nbVisibleItems", "onChange", "children"]);
    var providerValue = CarouselContext_1.useInitializeContext({
        index: index,
        loopeable: loopeable,
        nbVisibleItems: nbVisibleItems,
        onChange: onChange
    });
    return (react_1["default"].createElement(CarouselContext_1.CarouselContext.Provider, { value: providerValue },
        react_1["default"].createElement(Container_1.Container, __assign({ className: ['carousel', className] }, rest), children)));
};
exports.Carousel = Carousel;
//# sourceMappingURL=Carousel.js.map